import { jsx as ne } from "react/jsx-runtime";
import { gql as r, createHttpLink as ie, ApolloLink as se, split as de, from as ce, ApolloClient as me, InMemoryCache as ue, ApolloProvider as le } from "@apollo/client";
import { useState as pe, useEffect as fe } from "react";
import { GraphQLWsLink as be } from "@apollo/client/link/subscriptions";
import { createClient as Ie } from "graphql-ws";
import { setContext as P } from "@apollo/client/link/context";
import { getMainDefinition as he } from "@apollo/client/utilities";
import { ApolloLink as ge } from "@apollo/client/link/core/ApolloLink.js";
import { createSignalIfSupported as $e } from "@apollo/client/link/http/createSignalIfSupported.js";
import { parseAndCheckHttpResponse as ye } from "@apollo/client/link/http/parseAndCheckHttpResponse.js";
import { rewriteURIForGET as ke } from "@apollo/client/link/http/rewriteURIForGET.js";
import { selectHttpOptionsAndBodyInternal as Ue, fallbackHttpConfig as we, defaultPrinter as Te } from "@apollo/client/link/http/selectHttpOptionsAndBody.js";
import { selectURI as De } from "@apollo/client/link/http/selectURI.js";
import { serializeFetchParameter as v } from "@apollo/client/link/http/serializeFetchParameter.js";
import { Observable as F } from "@apollo/client/utilities/observables/Observable.js";
import Me from "axios";
function Se(e) {
  if (typeof e != "object" || e === null)
    return !1;
  const t = Object.getPrototypeOf(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}
function Be(e, t, o = "") {
  if (!arguments.length) throw new TypeError("Argument 1 `value` is required.");
  if (typeof t != "function")
    throw new TypeError("Argument 2 `isExtractable` must be a function.");
  if (typeof o != "string")
    throw new TypeError("Argument 3 `path` must be a string.");
  const a = /* @__PURE__ */ new Map(), i = /* @__PURE__ */ new Map();
  function m(s, g, U) {
    if (t(s)) {
      const p = i.get(s);
      return p ? p.push(g) : i.set(s, [g]), null;
    }
    const k = Array.isArray(s) || typeof FileList < "u" && s instanceof FileList, T = Se(s);
    if (k || T) {
      let p = a.get(s);
      const f = !p;
      if (f && (p = k ? [] : (
        // Replicate if the plain object is an `Object` instance.
        s instanceof /** @type {any} */
        Object ? {} : /* @__PURE__ */ Object.create(null)
      ), a.set(
        s,
        /** @type {Clone} */
        p
      )), !U.has(s)) {
        const n = g ? `${g}.` : "", d = new Set(U).add(s);
        if (k) {
          let c = 0;
          for (const b of s) {
            const D = m(
              b,
              n + c++,
              d
            );
            f && p.push(D);
          }
        } else
          for (const c in s) {
            const b = m(
              s[c],
              n + c,
              d
            );
            f && (p[c] = b);
          }
      }
      return p;
    }
    return s;
  }
  return {
    clone: m(e, o, /* @__PURE__ */ new Set()),
    files: i
  };
}
function _e(e, t, o) {
  "name" in o ? e.append(t, o, o.name) : e.append(t, o);
}
function Ae(e) {
  return typeof File < "u" && e instanceof File || typeof Blob < "u" && e instanceof Blob;
}
function Ne({
  uri: e = "/graphql",
  useGETForQueries: t,
  isExtractableFile: o = Ae,
  FormData: a,
  formDataAppendFile: i = _e,
  print: m = Te,
  fetch: s,
  fetchOptions: g,
  credentials: U,
  headers: k,
  includeExtensions: T
} = {}) {
  const p = {
    http: { includeExtensions: T },
    options: g,
    credentials: U,
    headers: k
  };
  return new ge((f) => {
    const n = (
      /**
       * @type {import("@apollo/client/core/types.js").DefaultContext & {
       *   clientAwareness?: {
       *     name?: string,
       *     version?: string,
       *   },
       * }}
       */
      f.getContext()
    ), {
      // Apollo Studio client awareness `name` and `version` can be configured
      // via `ApolloClient` constructor options:
      // https://www.apollographql.com/docs/graphos/metrics/client-awareness/#setup
      clientAwareness: { name: d, version: c } = {},
      headers: b
    } = n, D = {
      http: n.http,
      options: n.fetchOptions,
      credentials: n.credentials,
      headers: {
        // Client awareness headers can be overridden by context `headers`.
        ...d && { "apollographql-client-name": d },
        ...c && { "apollographql-client-version": c },
        ...b
      }
    }, { options: u, body: y } = Ue(
      f,
      m,
      we,
      p,
      D
    ), { clone: j, files: B } = Be(y, o, "");
    let _ = De(f, e);
    if (B.size) {
      u.headers && delete u.headers["content-type"];
      const I = a || FormData, h = new I();
      h.append("operations", v(j, "Payload"));
      const l = {};
      let A = 0;
      B.forEach((x) => {
        l[++A] = x;
      }), h.append("map", JSON.stringify(l)), A = 0, B.forEach((x, ae) => {
        i(h, String(++A), ae);
      }), u.body = h;
    } else if (t && // If the operation contains some mutations GET shouldn’t be used.
    !f.query.definitions.some(
      (I) => I.kind === "OperationDefinition" && I.operation === "mutation"
    ) && (u.method = "GET"), u.method === "GET") {
      const { newURI: I, parseError: h } = ke(_, y);
      if (h)
        return new F((l) => {
          l.error(h);
        });
      _ = I;
    } else u.body = v(j, "Payload");
    const { controller: w } = $e();
    typeof w != "boolean" && (u.signal && (u.signal.aborted ? (
      // Signal already aborted, so immediately abort.
      w.abort()
    ) : (
      // Signal not already aborted, so setup a listener to abort when it
      // does.
      u.signal.addEventListener(
        "abort",
        () => {
          w.abort();
        },
        {
          // Prevent a memory leak if the user configured abort controller
          // is long lasting, or controls multiple things.
          once: !0
        }
      )
    )), u.signal = w.signal);
    const re = s || fetch;
    return new F((I) => {
      let h;
      return re(_, u).then((l) => (f.setContext({ response: l }), l)).then(ye(f)).then((l) => {
        I.next(l), I.complete();
      }).catch((l) => {
        h || (l.result && l.result.errors && l.result.data && I.next(l.result), I.error(l));
      }), () => {
        h = !0, typeof w != "boolean" && w.abort();
      };
    });
  });
}
const N = "mage-cache-storage";
class S extends Error {
}
S.prototype.name = "InvalidTokenError";
function Ee(e) {
  return decodeURIComponent(atob(e).replace(/(.)/g, (t, o) => {
    let a = o.charCodeAt(0).toString(16).toUpperCase();
    return a.length < 2 && (a = "0" + a), "%" + a;
  }));
}
function Ce(e) {
  let t = e.replace(/-/g, "+").replace(/_/g, "/");
  switch (t.length % 4) {
    case 0:
      break;
    case 2:
      t += "==";
      break;
    case 3:
      t += "=";
      break;
    default:
      throw new Error("base64 string is not of the correct length");
  }
  try {
    return Ee(t);
  } catch {
    return atob(t);
  }
}
function Re(e, t) {
  if (typeof e != "string")
    throw new S("Invalid token specified: must be a string");
  t || (t = {});
  const o = t.header === !0 ? 0 : 1, a = e.split(".")[o];
  if (typeof a != "string")
    throw new S(`Invalid token specified: missing part #${o + 1}`);
  let i;
  try {
    i = Ce(a);
  } catch (m) {
    throw new S(`Invalid token specified: invalid base64 for part #${o + 1} (${m.message})`);
  }
  try {
    return JSON.parse(i);
  } catch (m) {
    throw new S(`Invalid token specified: invalid json for part #${o + 1} (${m.message})`);
  }
}
function q(e) {
  const t = Object.prototype.toString.call(e);
  return e instanceof Date || typeof e == "object" && t === "[object Date]" ? new e.constructor(+e) : typeof e == "number" || t === "[object Number]" || typeof e == "string" || t === "[object String]" ? new Date(e) : /* @__PURE__ */ new Date(NaN);
}
const Oe = 6e4;
function je(e) {
  return (t) => {
    const a = (e ? Math[e] : Math.trunc)(t);
    return a === 0 ? 0 : a;
  };
}
function xe(e, t) {
  return +q(e) - +q(t);
}
function H(e, t, o) {
  const a = xe(e, t) / Oe;
  return je(o?.roundingMethod)(a);
}
const Pe = (e, t) => window.localStorage.setItem(e, t), ve = (e) => window.localStorage.getItem(e), Fe = (e) => window.localStorage.removeItem(e), $ = {
  setItem: Pe,
  getItem: ve,
  removeItem: Fe
}, G = (e) => Re(e)?.expired_at, qe = (e) => {
  try {
    const t = G(e), o = (/* @__PURE__ */ new Date()).toISOString();
    return new Date(t) < new Date(o);
  } catch {
    return !0;
  }
}, Le = (e) => {
  try {
    const t = G(e);
    let o = 0;
    if (t) {
      const a = (/* @__PURE__ */ new Date()).toISOString();
      o = H(t, new Date(a));
    }
    return o < 5;
  } catch {
    return !0;
  }
}, Qe = () => $.getItem(N) ? JSON.parse($.getItem(N))?.customer?.signin_token : "", Je = Me.create();
function We() {
  return JSON.parse($.getItem(N) || "{}")?.customer || {};
}
async function Ke() {
  const e = We();
  if (e?.customer_id)
    return Promise.resolve(e.customer_id);
  try {
    return (await He())?.data?.id ?? "";
  } catch (t) {
    return console.error("Error while fetching customer", t), "";
  }
}
function He() {
  return Je("rest/default/V1/customers/me", {
    baseURL: "/",
    method: "GET",
    withCredentials: !0,
    headers: {
      "X-Requested-With": "XMLHttpRequest"
    }
  });
}
const Ge = {
  en: "en",
  fr: "fr",
  de: "de",
  it: "it",
  es: "es"
}, ze = () => {
  const e = location.pathname.replace(/^\/+/g, "").split("/")[0];
  return Ge[e];
};
function Ye(e) {
  const t = Object.fromEntries(
    document.cookie.split("; ").map((o) => o.split("="))
  );
  return t[e] ? decodeURIComponent(t[e]) : null;
}
function Ve() {
  return Ye("loggedIn");
}
const Xe = [
  "countries",
  "projectUsers",
  "projectUserSuggestions",
  "notes",
  "types",
  "phases",
  "project",
  "projectByExternalID",
  "projects"
], Ze = [
  "createProjectUser",
  "updateProjectUser",
  "deleteProjectUser",
  "Auth",
  "createNote",
  "updateNote",
  "deleteNote",
  "readNotes",
  "evaluateTypes",
  "createProject",
  "patchProject",
  "deleteProject",
  "transferProject"
], et = [
  "healthcheck",
  "watchNotes",
  "watchNotesSummary"
], tt = [
  ...et,
  ...Ze,
  ...Xe
], L = {
  "materialbank.test": "http://localhost:8081",
  "dev.materialbank.com": "https://mb-projects-uat.usw2.materialbank.com",
  "stage2.materialbank.com": "https://mb-projects-uat.usw2.materialbank.com",
  "uat2.materialbank.com": "https://mb-projects-uat.usw2.materialbank.com",
  "uat.materialbank.eu": "https://mb-projects-uat.dev.materialbank.eu",
  "www.materialbank.eu": "https://projects.p.materialbank.eu",
  "www.materialbank.com": "https://projects.p.materialbank.com",
  default: "https://mb-projects-uat.usw2.materialbank.com"
}, z = "projects.accessToken";
function E(e, t) {
  $.setItem(
    z,
    JSON.stringify({
      [t]: e
    })
  );
}
function ot() {
  try {
    return JSON.parse($.getItem(z) ?? "{}");
  } catch {
    return {};
  }
}
const Q = "private-content-loaded", Y = async (e) => {
  let t = Qe();
  return t || (t = await new Promise((o) => {
    const a = (i) => {
      const m = i;
      window.removeEventListener(Q, a);
      const s = m.detail.data;
      o(s.customer.signin_token);
    };
    window.addEventListener(Q, a);
  })), fetch(e, {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({
      query: `
        mutation Auth($exToken: String!) {
          Auth(exToken: $exToken) {
            token
          }
        }
      `,
      variables: {
        exToken: t
      }
    })
  });
}, rt = async (e, t) => {
  try {
    const i = (await (await Y(e)).json()).data.Auth?.token || "";
    return E(i, t), i;
  } catch (o) {
    return console.error(o), "";
  }
}, at = (e, t) => {
  Y(e).then(
    (o) => {
      o.json().then((a) => {
        const i = a.data.Auth?.token || "";
        E(i, t);
      });
    },
    (o) => {
      console.error(o), E("", t);
    }
  );
}, nt = () => {
  const e = window.location.hostname;
  return L[e] ?? L.default;
}, it = [
  "Auth",
  "Board",
  "BoardOwnerDetails",
  "BoardProjects",
  "BoardUsers",
  "Boards",
  "ItemNotes",
  "Items",
  "MaterialExport",
  "MaterialExportTemplates",
  "Moodboard",
  "MoodboardComments",
  "PinterestBoards",
  "PinterestPinsOnBoard",
  "PublicBoard",
  "RenewToken",
  "Tags"
], st = [
  "archiveMoodboardThreads",
  "copyBoard",
  "copyItem",
  "copyMoodboard",
  "createBoard",
  "createBoardUser",
  "createItem",
  "createItemNote",
  "createMaterialExportTemplate",
  "createMoodboard",
  "createMoodboardComment",
  "createRepOrder",
  "deleteBoard",
  "deleteBoardProduct",
  "deleteBoardUser",
  "deleteItem",
  "deleteItemNote",
  "deleteMaterialExportTemplate",
  "deleteMoodboard",
  "deleteMoodboardComment",
  "pinterestAuthExchangeCode",
  "pinterestAuthRefreshToken",
  "readItemNotes",
  "removeBackgroundForMoodBoard",
  "unarchiveMoodboardThreads",
  "updateBoard",
  "updateBoardUser",
  "updateItem",
  "updateItemNote",
  "updateMaterialExportTemplate",
  "updateMoodboard",
  "updateMoodboardComment"
], dt = [
  "healthcheck",
  "watchBoardSummary",
  "watchItemNotes",
  "watchMoodboardComments",
  "watchMoodboardSummary"
], ct = [
  ...dt,
  ...st,
  ...it
], mt = {
  appDataStorageKey: "mage-cache-storage"
}, { appDataStorageKey: J } = mt, W = {
  "materialbank.test": "http://localhost:8080",
  "stage2.materialbank.com": "https://mb-boards-uat.usw2.materialbank.com",
  "uat2.materialbank.com": "https://mb-boards-uat.usw2.materialbank.com",
  "uat.materialbank.eu": "https://mb-boards-uat.dev.materialbank.eu",
  "www.materialbank.eu": "https://boards.p.materialbank.eu",
  "www.materialbank.com": "https://boards.p.materialbank.com",
  default: "https://mb-boards-uat.usw2.materialbank.com"
};
r`
  mutation ArchiveMoodboardThreadsMutation(
    $moodboardId: UUID!
    $threadIds: [UUID!]!
  ) {
    archiveMoodboardThreads(moodboardId: $moodboardId, threadIds: $threadIds)
  }
`;
r`
  mutation CopyBoard($id: UUID!) {
    copyBoard(id: $id) {
      name
    }
  }
`;
r`
  mutation CopyMoodboardMutation($id: UUID!) {
    copyMoodboard(id: $id) {
      id
      name
    }
  }
`;
r`
  mutation CopyToBoardMutation($id: UUID!, $boardId: UUID!) {
    copyItem(id: $id, boardId: $boardId) {
      id
    }
  }
`;
r`
  mutation CreateBoard($input: createBoard!) {
    createBoard(input: $input) {
      name
      slug
    }
  }
`;
r`
  mutation CreateBoardUser($boardId: UUID!, $input: createBoardUser!) {
    createBoardUser(boardId: $boardId, input: $input) {
      id
      firstName
      lastName
      email
      unregisteredEmail
      type
    }
  }
`;
r`
  mutation CreateItemMutation($boardId: UUID!, $input: ItemInput!) {
    createItem(boardId: $boardId, input: $input) {
      id
      name
      type
    }
  }
`;
r`
  mutation CreateItemNoteMutation($itemId: UUID!, $input: ItemNoteInput!) {
    createItemNote(itemId: $itemId, input: $input) {
      id
      isPublic
      note
      createdAt
      updatedAt
      user {
        userRef
        firstName
        lastName
        imageUrl
      }
    }
  }
`;
r`
  mutation CreateMaterialExportTemplate(
    $input: CreateMaterialExportTemplateInput!
  ) {
    createMaterialExportTemplate(input: $input) {
      id
      name
      items {
        key
        isActive
        position
      }
    }
  }
`;
r`
  mutation CreateMoodboardCommentMutation(
    $moodboardId: UUID!
    $input: createMoodboardComment!
  ) {
    createMoodboardComment(moodboardId: $moodboardId, input: $input) {
      id
      comment
      createdAt
      updatedAt
      user {
        userRef
        firstName
        lastName
        imageUrl
      }
    }
  }
`;
r`
  mutation CreateMoodboardMutation($boardID: UUID!, $input: MoodboardInput!) {
    createMoodboard(boardID: $boardID, input: $input) {
      id
      name
    }
  }
`;
r`
  mutation CreateRepOrderMutation(
    $token: String!
    $input: CreateRepOrderInput!
  ) {
    createRepOrder(token: $token, input: $input) {
      orderId
      orderNumber
      deliveryMessage
    }
  }
`;
r`
  mutation DeleteBoardProduct($boardId: UUID!, $productRef: Int!) {
    deleteBoardProduct(boardId: $boardId, productRef: $productRef) {
      id
    }
  }
`;
r`
  mutation DeleteBoardItemMutation($id: UUID!) {
    deleteItem(id: $id) {
      id
    }
  }
`;
r`
  mutation DeleteBoard($id: UUID!) {
    deleteBoard(id: $id)
  }
`;
r`
  mutation DeleteBoardUser($id: UUID!) {
    deleteBoardUser(id: $id)
  }
`;
r`
  mutation DeleteItemNoteMutation($noteId: UUID!) {
    deleteItemNote(noteId: $noteId) {
      id
      isPublic
    }
  }
`;
r`
  mutation DeleteMaterialExportTemplate($id: UUID!) {
    deleteMaterialExportTemplate(id: $id)
  }
`;
r`
  mutation DeleteMoodboardCommentMutation($commentId: UUID!) {
    deleteMoodboardComment(commentId: $commentId) {
      id
      comment
      createdAt
      updatedAt
      user {
        userRef
        firstName
        lastName
        imageUrl
      }
    }
  }
`;
r`
  mutation DeleteMoodboardMutation($id: UUID!) {
    deleteMoodboard(id: $id) {
      id
    }
  }
`;
r`
  mutation RemoveBackgroundForMoodBoardMutation(
    $moodboardId: UUID!
    $imageUrl: String!
  ) {
    removeBackgroundForMoodBoard(moodboardId: $moodboardId, imageUrl: $imageUrl)
  }
`;
r`
  mutation PinterestAuthExchangeCode($code: String!, $redirectUri: String!) {
    pinterestAuthExchangeCode(code: $code, redirectUri: $redirectUri) {
      accessToken
      refreshToken
      responseType
      tokenType
      expiresIn
      refreshTokenExpiresIn
      scope
    }
  }
`;
r`
  mutation PinterestAuthRefreshToken($refreshToken: String!) {
    pinterestAuthRefreshToken(refreshToken: $refreshToken) {
      accessToken
      refreshToken
      responseType
      tokenType
      expiresIn
      refreshTokenExpiresIn
      scope
    }
  }
`;
r`
  mutation ReadItemNotes($itemId: UUID!) {
    readItemNotes(itemId: $itemId)
  }
`;
r`
  mutation UnarchiveMoodboardThreadsMutation(
    $moodboardId: UUID!
    $threadIds: [UUID!]!
  ) {
    unarchiveMoodboardThreads(moodboardId: $moodboardId, threadIds: $threadIds)
  }
`;
r`
  mutation UpdateBoardMutation($id: UUID!, $input: updateBoard!) {
    updateBoard(id: $id, input: $input) {
      id
      name
      description
      projectRef
      publicRef
      showOwnerDetails
      distributeToReps
      type
      activeMoodboardId
    }
  }
`;
r`
  mutation UpdateBoardUser($id: UUID!, $input: updateBoardUser!) {
    updateBoardUser(id: $id, input: $input) {
      id
      firstName
      lastName
      email
      unregisteredEmail
      type
    }
  }
`;
r`
  mutation UpdateItemMutation($id: UUID!, $input: ItemInput!) {
    updateItem(id: $id, input: $input) {
      id
      position
      name
      status
      attributes {
        name
        value
      }
      tags {
        id
        name
      }
    }
  }
`;
r`
  mutation UpdateItemNoteMutation($noteId: UUID!, $input: ItemNoteInput!) {
    updateItemNote(noteId: $noteId, input: $input) {
      id
      isPublic
      note
      createdAt
      updatedAt
      user {
        firstName
        lastName
        imageUrl
        userRef
      }
    }
  }
`;
r`
  mutation UpdateMaterialExportTemplate(
    $id: UUID!
    $input: UpdateMaterialExportTemplateInput!
  ) {
    updateMaterialExportTemplate(id: $id, input: $input) {
      id
      name
      items {
        key
        isActive
        position
      }
    }
  }
`;
r`
  mutation UpdateMoodboardCommentMutation(
    $commentId: UUID!
    $comment: String!
  ) {
    updateMoodboardComment(commentId: $commentId, comment: $comment) {
      id
      comment
      createdAt
      updatedAt
      user {
        userRef
        firstName
        lastName
        imageUrl
      }
    }
  }
`;
r`
  mutation UpdateMoodboardMutation($id: UUID!, $input: MoodboardInput!) {
    updateMoodboard(id: $id, input: $input) {
      id
      name
      payload
    }
  }
`;
r`
  query BoardsQuery(
    $sort: BoardsSortableField
    $order: Order
    $projectRef: String
    $archived: Boolean
    $brandRef: String
    $limit: Int
    $filter: BoardFilterInput
  ) {
    Boards(
      sort: $sort
      order: $order
      projectRef: $projectRef
      archived: $archived
      brandRef: $brandRef
      limit: $limit
      filter: $filter
    ) {
      id
      name
      slug
      items {
        id
        type
        name
        imageUrl
        description
        position
        sampled
        source
        status
        associatedProduct {
          _id
          imageUrl
          name
          manufacturer
        }
        attributes {
          name
          value
        }
        tags {
          id
          name
        }
        product {
          _id
          entity_id
          name
          url
          brand_product
          price_sign
          manufacturer
          residential_commercial
          associated_finish_products
          imageUrl
          thumbnailImageUrl
          ss_item_type
          family_id
          sku
          ss_facet_color_filter {
            entity_id
          }
          categories
          taxonomy_l2
          taxonomy_l3
          taxonomy_l4
          install_images
          qty
          components {
            items {
              name
            }
          }
          product_finish_type
          is_orderable
          is_digital
          status
          install_images
        }
      }
    }
  }
`;
const V = r`
  fragment BoardDetails on Board {
    id
    name
    type
    archived
    name
    projectRef
    description
    publicRef
    permission
    showOwnerDetails
    distributeToReps
    coverUrl
    hasCustomCover
    coverItemRef
    tags {
      id
      name
    }
    moodboards {
      id
      name
    }
    activeMoodboardId
    items(sort: $sort) {
      id
      type
      name
      imageUrl
      description
      position
      sampled
      source
      status
      associatedProduct {
        _id
        imageUrl
        name
        manufacturer
      }
      attributes {
        name
        value
      }
      tags {
        id
        name
      }
      product {
        _id
        entity_id
        name
        url
        brand_product
        price_sign
        manufacturer
        residential_commercial
        associated_finish_products
        imageUrl
        thumbnailImageUrl
        ss_item_type
        family_id
        sku
        ss_facet_color_filter {
          entity_id
        }
        categories
        taxonomy_l2
        taxonomy_l3
        taxonomy_l4
        install_images
        qty
        components {
          items {
            name
          }
        }
        product_finish_type
        is_orderable
        is_digital
        status
        install_images
      }
    }
  }
`;
r`
  ${V}

  query BoardDetailsQuery($slug: String!, $sort: String) {
    Board(slug: $slug) {
      ...BoardDetails
    }
  }
`;
r`
  ${V}

  query PublicBoardDetailsQuery($slug: String!, $sort: String) {
    PublicBoard(token: $slug) {
      ...BoardDetails
    }
  }
`;
r`
  query BoardDetailsTagsQuery($slug: String!) {
    Board(slug: $slug) {
      tags {
        id
        name
      }
    }
  }
`;
r`
  query PublicBoardDetailsTagsQuery($slug: String!) {
    PublicBoard(token: $slug) {
      tags {
        id
        name
      }
    }
  }
`;
r`
  query BoardOwnerDetailsQuery($boardId: UUID!) {
    BoardOwnerDetails(boardId: $boardId) {
      firstName
      lastName
      companyName
      location
      imageUrl
      rep
      email
    }
  }
`;
r`
  query BoardProjects {
    BoardProjects
  }
`;
r`
  query BoardsQuery(
    $sort: BoardsSortableField
    $order: Order
    $projectRef: String
    $archived: Boolean
    $brandRef: String
    $limit: Int
  ) {
    Boards(
      sort: $sort
      order: $order
      projectRef: $projectRef
      archived: $archived
      brandRef: $brandRef
      limit: $limit
    ) {
      id
      name
      slug
    }
  }
`;
r`
  query BoardsQuery(
    $sort: BoardsSortableField
    $order: Order
    $projectRef: String
    $archived: Boolean
    $brandRef: String
    $limit: Int
  ) {
    Boards(
      sort: $sort
      order: $order
      projectRef: $projectRef
      archived: $archived
      brandRef: $brandRef
      limit: $limit
    ) {
      id
      name
      slug
      projectRef
      archived
      itemsCount
      covers
      coverUrl
      hasCustomCover
      publicRef
      permission
      type
      showOwnerDetails
      distributeToReps
      items {
        id
        name
        imageUrl
        product {
          categories
          url
          _id
          country_permission
          entity_id
          family_id
          image_scale_factor
          indoor_outdoor_use
          is_collection
          is_new
          is_orderable
          is_primary
          just_added
          is_digital
          light_reflectance_value
          manufacturer
          manufacturer_alias
          manufacturer_sku
          ss_item_type
          status
        }
      }
    }
  }
`;
r`
  query BoardsQueryWithFilters(
    $sort: BoardsSortableField
    $order: Order
    $projectRef: String
    $archived: Boolean
    $filter: BoardFilterInput
  ) {
    Boards(
      sort: $sort
      order: $order
      projectRef: $projectRef
      archived: $archived
      filter: $filter
    ) {
      id
      name
    }
  }
`;
r`
  query BoardUsersQuery($boardId: UUID!) {
    BoardUsers(boardId: $boardId) {
      id
      userRef
      firstName
      lastName
      email
      type
      unregisteredEmail
      isEditable
      source
    }
  }
`;
r`
  query ItemNotesQuery($itemId: UUID!) {
    ItemNotes(itemId: $itemId) {
      id
      isPublic
      note
      user {
        firstName
        lastName
        imageUrl
        userRef
      }
      updatedAt
      createdAt
    }
  }
`;
r`
  query MaterialExportQuery($boardId: UUID!, $itemIds: [UUID!]) {
    MaterialExport(boardId: $boardId, itemIds: $itemIds) {
      projectInfo {
        title
        description
        phaseLabel
      }
      rows {
        id
        name
        manufactureSku
        brand
        indoorOutdoorUse
        urlKey
        residentialCommercial
        color
        primaryColor
        collectionName
        contentTextile
        priceSign
        patternScale
        finishTreatment
        stainResistance
        durability
        carpetDyeMethod
        flammabilityTest
        thicknessPileHeightCarpet
        climateImpact
        humanHealthImpact
        socialEquityImpact
        tags
        abrasionWearResistance
        acoustics
        ada
        classification
        emissions
        flammability
        slipResistance
        globalWarmingPotential
        width
        tileType
        contentTestAttribute
        construction
        status
        image
        sku
        associatedProductBrand
        associatedProductName
      }
    }
  }
`;
r`
  query MaterialExportTemplatesQuery {
    MaterialExportTemplates {
      id
      name
      type
      items {
        key
        isActive
        position
      }
    }
  }
`;
r`
  query MoodboardComments($threadId: UUID!) {
    MoodboardComments(threadId: $threadId) {
      id
      comment
      createdAt
      updatedAt
      user {
        userRef
        firstName
        lastName
        imageUrl
      }
    }
  }
`;
r`
  query MoodboardDetailsQuery($id: UUID!) {
    Moodboard(id: $id) {
      id
      name
      payload
    }
  }
`;
r`
  query PinterestPinsOnBoard(
    $accessToken: String!
    $boardID: String!
    $params: PinterestListParams
  ) {
    PinterestPinsOnBoard(
      accessToken: $accessToken
      boardID: $boardID
      params: $params
    ) {
      bookmark
      items {
        id
        title
        media
      }
    }
  }
`;
r`
  query PinterestBoards($accessToken: String!, $params: PinterestListParams) {
    PinterestBoards(accessToken: $accessToken, params: $params) {
      bookmark
      items {
        id
        name
        pinCount
        media
        owner {
          username
        }
      }
    }
  }
`;
r`
  query UserTagsQuery {
    Tags {
      id
      name
    }
  }
`;
r`
  subscription WatchBoardSummary($boardId: UUID!) {
    watchBoardSummary(boardId: $boardId) {
      boardId
      itemNotes {
        itemID
        hasNewNotes
        notesCount
      }
    }
  }
`;
r`
  subscription ItemNotesSubscribe($itemId: UUID!) {
    watchItemNotes(itemId: $itemId) {
      type
      note {
        id
        isPublic
        note
        user {
          firstName
          lastName
          imageUrl
          userRef
        }
        updatedAt
        createdAt
      }
    }
  }
`;
r`
  subscription MoodboardCommentsSubscription(
    $moodboardId: UUID!
    $threadId: UUID!
  ) {
    watchMoodboardComments(moodboardId: $moodboardId, threadId: $threadId) {
      type
      comment {
        id
        comment
        createdAt
        updatedAt
        user {
          userRef
          firstName
          lastName
          imageUrl
        }
      }
    }
  }
`;
r`
  subscription MoodboardSummarySubscription($moodboardId: UUID!) {
    watchMoodboardSummary(moodboardId: $moodboardId) {
      comments {
        commentsCount
        threadId
        lastComment {
          id
          comment
          createdAt
          updatedAt
          user {
            userRef
            firstName
            lastName
            imageUrl
          }
        }
      }
    }
  }
`;
const X = "boards.accessToken", Z = (e) => {
  const t = e.split(".").pop() || "";
  return JSON.parse(atob(t))?.expiresAt || "";
}, ut = (e) => {
  const t = Z(e), o = (/* @__PURE__ */ new Date()).toISOString();
  return new Date(t) < new Date(o);
}, lt = (e) => {
  try {
    const t = Z(e);
    let o = 0;
    if (t) {
      const a = (/* @__PURE__ */ new Date()).toISOString();
      o = H(t, new Date(a));
    }
    return o < 5;
  } catch {
    return !0;
  }
};
function C(e, t) {
  $.setItem(
    X,
    JSON.stringify({
      [t]: e
    })
  );
}
const pt = () => $.getItem(J) ? JSON.parse($.getItem(J))?.customer?.signin_token : "";
function ft() {
  try {
    return JSON.parse($.getItem(X) ?? "{}");
  } catch {
    return {};
  }
}
const K = "private-content-loaded", ee = async (e) => {
  let t = pt();
  return t || (t = await new Promise((o) => {
    const a = (i) => {
      const m = i;
      window.removeEventListener(K, a);
      const s = m.detail.data;
      o(s.customer.signin_token);
    };
    window.addEventListener(K, a);
  })), fetch(e, {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({
      query: `
        query Auth($exToken: String!) {
          Auth(exToken: $exToken) {
            token
          }
        }
      `,
      variables: {
        exToken: t
      }
    })
  });
}, bt = async (e, t) => {
  try {
    const i = (await (await ee(e)).json()).data.Auth?.token || "";
    return C(i, t), i;
  } catch (o) {
    return console.error(o), "";
  }
}, It = (e, t) => {
  ee(e).then(
    (o) => {
      o.json().then((a) => {
        const i = a.data.Auth?.token || "";
        C(i, t);
      });
    },
    (o) => {
      console.error(o), C("", t);
    }
  );
}, ht = () => {
  const e = window.location.hostname;
  return W[e] ?? W.default;
}, gt = `${ht()}/api/v1/query`, te = `${nt()}/api/v1/query`, M = "apollo-client", $t = tt, yt = ct;
var oe = /* @__PURE__ */ ((e) => (e.PROJECT = "projectOperations", e.BOARD = "boardOperations", e))(oe || {});
const kt = {
  projectOperations: $t,
  boardOperations: yt
}, R = {
  projectOperations: te,
  boardOperations: gt
};
function Ut(e) {
  const o = e?.query?.definitions.find(
    (i) => i.kind === "OperationDefinition"
  );
  return (
    // @ts-ignore ignoring due to tsc not being able to infer the type of operationDefinition in each application
    o?.selectionSet?.selections?.[0]?.kind === "Field" ? (
      // @ts-ignore ignoring due to tsc not being able to infer the type of operationDefinition in each application
      o.selectionSet.selections[0].name.value
    ) : void 0
  );
}
function O(e) {
  const t = Ut(e);
  return t ? Object.values(oe).find(
    (o) => kt[o].includes(t)
  ) ?? null : null;
}
function wt(e, t) {
  if (!t)
    return e;
  const o = O(t);
  return o ? R[o] : e;
}
const Tt = {
  projectOperations: {
    getAccessTokenFromStorage: ot,
    createToken: rt,
    refreshToken: at,
    shouldRefresh: Le,
    isExpired: qe
  },
  boardOperations: {
    getAccessTokenFromStorage: ft,
    createToken: bt,
    refreshToken: It,
    shouldRefresh: lt,
    isExpired: ut
  }
};
function Dt({ buildUri: e, defaultUri: t }) {
  const [o, a] = pe(null), i = async (n, d) => {
    let c = null;
    if (d ? c = d : n && (c = O(n)), !c)
      return "";
    const b = Tt[c];
    let D = b.getAccessTokenFromStorage();
    const u = await Ke();
    let y = D[u];
    return (!y || b.isExpired(y)) && (y = await b.createToken(
      e(t, n),
      u
    )), b.shouldRefresh(y) && b.refreshToken(e(t, n), u), `Bearer ${y}`;
  }, m = ie({
    uri: (n) => e(t, n)
  }), s = Ne({
    uri: (n) => e(t, n)
  }), g = P(async (n, { headers: d }) => ({ headers: { ...d, "Accept-Language": ze() || "en" } })), U = Object.keys(R).reduce(
    (n, d) => (n[d] = new be(
      Ie({
        url: R[d],
        connectionParams: async () => ({
          Authorization: await i(
            void 0,
            d
          )
        }),
        retryAttempts: 5
      })
    ), n),
    {}
  ), k = (n) => U[O(n) || ""], T = P(async (n, { headers: d }) => {
    if (!Ve())
      return d;
    const c = await i(n);
    return {
      headers: {
        ...d,
        authorization: c ?? ""
      }
    };
  }), p = new se((n) => k(n).request(n)), f = de(
    ({ query: n }) => {
      const d = he(n);
      return d.kind === "OperationDefinition" && d.operation === "subscription";
    },
    p,
    // Send subscription operations through the WebSocket
    T
    // Send queries/mutations through the HTTP link
  );
  return fe(() => {
    if (window[M]) {
      o || a(window[M]);
      return;
    }
    const n = ce([g, f, s]), d = new me({
      link: n,
      cache: new ue()
    });
    if (window[M]) {
      a(window[M]);
      return;
    }
    window[M] = d, a(d);
  }, [o, m, g, f, s]), {
    client: o,
    generateBearerToken: i
  };
}
function Lt({ children: e }) {
  const { client: t } = Dt({ buildUri: wt, defaultUri: te });
  return t ? /* @__PURE__ */ ne(le, { client: t, children: e }) : null;
}
export {
  Lt as ApolloProvider
};
